/* eslint-disable react/no-unescaped-entities */
/**
 * MaintenanceGate — intercepteur global de routes en mode maintenance.
 *
 * Comportement
 *  - Au montage, fetch /api/maintenance/status
 *  - Si enabled=true ET la route courante n'est pas whitelistée → affiche
 *    `<MaintenancePage />` à la place de l'app
 *  - Re-poll toutes les 30s pour détecter la sortie de maintenance sans recharger
 *
 * Routes ALWAYS-ON (jamais bloquées) :
 *  - `/admin/*`  (back-office reste accessible pour désactiver le mode)
 *  - `/login`    (l'admin doit pouvoir s'authentifier)
 *  - `/maintenance` (page de status si l'admin veut la voir)
 */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { apiClient } from "@/lib/api";
import MaintenancePage from "@/pages/Maintenance";

const WHITELIST_PREFIXES = ["/admin", "/login", "/maintenance", "/negociation/invitation"];

function isWhitelisted(pathname) {
  return WHITELIST_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));
}

export default function MaintenanceGate({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ enabled: false, message: "", loaded: false });

  useEffect(() => {
    let mounted = true;
    const fetchStatus = async () => {
      try {
        const { data } = await apiClient.get("/maintenance/status");
        if (mounted) setState({ enabled: !!data.enabled, message: data.message || "", loaded: true });
      } catch {
        // En cas d'échec API on n'active PAS la maintenance (fail-open)
        if (mounted) setState((s) => ({ ...s, loaded: true }));
      }
    };
    fetchStatus();
    const interval = setInterval(fetchStatus, 30_000);
    return () => { mounted = false; clearInterval(interval); };
  }, []);

  // Tant que le statut n'est pas chargé, on rend l'app pour éviter un flash blanc
  if (!state.loaded) return children;
  if (!state.enabled) return children;
  if (isWhitelisted(location.pathname)) return children;
  return <MaintenancePage message={state.message} />;
}
